import axios from 'axios';
console.log(process.env);
const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_BACKEND_URL}/`,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
    },
    timeout: 60000,
});

// Add a request interceptor to handle authorization if needed
apiClient.interceptors.request.use(config => {
    // const userData = JSON.parse(localStorage.getItem('user')); // Retrieve and parse the user data
    // const token = userData?.token; // Access the token property if userData exists
    //
    // if (token) {
    //     config.headers.Authorization = `Bearer ${token}`;
    // }
    // return config;
    const userDataString = localStorage.getItem('user'); // Retrieve the raw string
    let userData = null;

    try {
        userData = userDataString ? JSON.parse(userDataString) : null; // Parse only if not null
    } catch (error) {
        console.error('Failed to parse user data from localStorage:', error);
    }

    const token = userData?.token; // Access the token property if userData exists

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, error => Promise.reject(error));

// Add a response interceptor for handling errors
apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Handle unauthorized access, possibly by redirecting to login
            this.$router.push('')
        }
        return Promise.reject(error);
    }
);

export default apiClient;
